import { AxiosRequestConfig } from "axios";

export const patchUserInformationConfig = (
  authorization: string | undefined
): AxiosRequestConfig => ({
  method: "patch",
  url: "/me/profile",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: authorization && `Bearer ${authorization}`,
  },
});
